import {
  Box,
  Button,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import RefreshIcon from "@material-ui/icons/Refresh";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { AppState } from "../redux/AppTypes";
import { FETCH_REGIONS, REMOVE_REGION } from "./RegionTypes";
import useSortedRegions from "./useSortedRegions";

export function RegionsPanel() {
  const history = useHistory();
  const dispatch = useDispatch();
  const regions = useSortedRegions();
  const nextToken = useSelector((state: AppState) => state.regions.nextToken);
  const synching = useSelector((state: AppState) => state.regions.synching);
  const year = new Date().getFullYear();

  useEffect(() => {
    dispatch({ type: FETCH_REGIONS, paginated: true });
  }, [dispatch]);

  return (
    <Box>
      <Grid>
        <Tooltip title="Add">
          <Button
            onClick={() => history.push(`/administration/regions/`)}
            color="primary"
            variant="contained"
          >
            New region
          </Button>
        </Tooltip>
        <Tooltip title="Refresh">
          <IconButton onClick={() => dispatch({ type: FETCH_REGIONS, paginated: true })}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </Grid>

      <Grid container>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Code</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Holidays in {year}</TableCell>
                <TableCell>Working hours</TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody data-testid="regions-table-body">
              {regions.map((item, index) => {
                return (
                  <TableRow key={item.id}>
                    <TableCell>
                      {index + 1}. {item.code}
                    </TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>{item.countHolidaysInYear(year)}</TableCell>
                    <TableCell>{item.workingHours}</TableCell>
                    <TableCell align="right">
                      <Tooltip title="Edit">
                        <IconButton
                          onClick={() =>
                            history.push(`/administration/regions/${item.id}`)
                          }
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton
                          onClick={() => {
                            dispatch({ type: REMOVE_REGION, id: item.id });
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        {nextToken ? (
          <Box marginTop={2} width="100%" display="flex" justifyContent="flex-end">
            <Button
              disabled={synching}
              onClick={() =>
                dispatch({
                  type: FETCH_REGIONS,
                  append: true,
                  nextToken,
                  paginated: true,
                })
              }
            >
              Load more
            </Button>
          </Box>
        ) : null}
      </Grid>
    </Box>
  );
}
